var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.353,
    height: 20.353,
    viewBox: "0 0 20.353 20.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20.353V-20.353H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.353)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 -1.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.37a1.366,1.366,0,0,1-.969-.4,1.371,1.371,0,0,1,0-1.938L16.643-18.581a1.371,1.371,0,0,1,1.938,0,1.371,1.371,0,0,1,0,1.938L.969.969A1.366,1.366,0,0,1,0,1.37Z",
    fill: "#00b8f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.984 -1.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.37a1.366,1.366,0,0,1-.969-.4L-18.581-16.643a1.371,1.371,0,0,1,0-1.938,1.371,1.371,0,0,1,1.938,0L.969-.969a1.371,1.371,0,0,1,0,1.938A1.366,1.366,0,0,1,0,1.37Z",
    fill: "#00b8f1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.80ac7d082491726ad09c7685bc4875df.svg";
export { ForwardRef as ReactComponent };